import React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { renderFilterDropdowns } from "../../UniversalCRMTable/utils/filter-rendering";
import { getDatetimePresets } from "@/lib/utils/formatting/datetime-presets";
import { BaseEntity, SimpleTableConfigBase } from "../../UniversalCRMTable/types/shared";
import { FilterControlsProps } from "../types";

/**
 * Filter controls component - search and filter dropdowns
 */
export function FilterControls<T extends BaseEntity>({
  config,
  searchTerm,
  setSearchTerm,
  filters,
  setFilters,
}: FilterControlsProps<T>) {
  return (
    <div className="space-y-3">
      <div className="bg-card-50 border border-gray-200 dark:border-gray-700 rounded-lg p-4 space-y-3">
        {/* Search */}
        {config.features?.search && (
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
            <Input
              placeholder={`Search ${config.displayName.toLowerCase()}...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm?.(e.target.value)}
              className="pl-10 w-full"
            />
          </div>
        )}

        {/* Filters - Desktop dropdowns */}
        {config.features?.filters && (
          <div className="flex flex-wrap gap-2">
            {renderFilterDropdowns(
              config as SimpleTableConfigBase<T>,
              filters || {},
              (newFilters) => setFilters?.(newFilters),
              getDatetimePresets
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// Made with Bob
